import { Navigate } from 'react-router';

import useAuth from '../../hooks/useAuth';
import { hasStoredRoles } from '../../hooks/useHasPermission';

const AuthVerifyView = () => {
  const { token } = useAuth();

  if (token) {
    return <Navigate to={hasStoredRoles() ? 'cases' : 'manage-account'} />;
  }

  return <div></div>;
};

export default AuthVerifyView;